import { RefreshCw } from "lucide-react";
import { useAppUpdate } from "@/hooks/useAppUpdate";

export function UpdateBanner() {
  const { updateAvailable, refresh } = useAppUpdate();
  if (!updateAvailable) return null;
  return (
    <div className="fixed bottom-24 md:bottom-4 left-1/2 -translate-x-1/2 z-[60] w-[calc(100%-2rem)] max-w-md" data-testid="app-update-banner">
      <div className="rounded-md border border-[#83B68B]/60 bg-[#0A0F1C] text-white shadow-2xl p-4 flex items-center gap-3">
        <RefreshCw className="w-5 h-5 text-[#83B68B] flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="font-display font-bold text-sm">A new version of the app is ready</div>
          <div className="text-xs opacity-70">Refresh to get the latest features and fixes.</div>
        </div>
        <button type="button" onClick={refresh} data-testid="app-update-refresh-btn" className="btn-volt px-4 py-2 rounded text-[10px] tracking-widest uppercase whitespace-nowrap">Refresh</button>
      </div>
    </div>
  );
}
